import React, { useRef, useState } from "react";
import "../Header/header.css";
import Container from "../Container/Index";
import Logo from '../Header/Logo/Index';
import Navbar from "../Header/Navbar/Index";
import useStickyHeader from "./useStickyHeader";
import { Link, useLocation } from "react-router-dom";
import FixedSticky from "../Sticky/FixedSticky";

const Header = ({ relativeHeader = "" }) => {
  const headerRef = useRef(null);
  useStickyHeader(headerRef);
  const location = useLocation();
  const isCurrentpage = location.pathname === '/outsource-your-bottling';


  const [menuData] = useState([
    { name: "Home", link: "/" },
    { name: "ABOUT US", link: '/about-arsus-global' },
    { name: "OUR SERVICES ", link: '/our-services' },
    { name: "OUR FACILITY ", link: '/our-facility' },
    { name: "Our Clients", link: '/our-clients' },
    { name: "SUSTAINABILITY", link: '/sustainability'},
  ]);


  return (
   <>
    <header className='col-12 float-start d-lg-flex align-items-center overflow-hidden'>
      <Container _parentClass={`header header-border top-0 ${relativeHeader}`}  ref={headerRef}>
        <div className='row align-items-end m-0'>
        <div className="col-lg-2 col-7">
          <div
            className="logo"
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-duration="500"
            data-aos-once="true"
            data-aos-easing="ease-in-sine"
          >
            <Link to="/">
              <Logo />
            </Link>
          </div>
        </div>
        <div className="col-lg-10 col-5">
            <Navbar menuData={menuData} />
        </div>
        </div>
      </Container>
     
    </header>
    <div className="StickyCtas">
      {!isCurrentpage && <FixedSticky />}
    </div>
   </>
  );
};

export default Header;